import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from './useAuth'

interface AdminGuardProps {
  children: ReactNode
}

const DEV_SKIP_AUTH = import.meta.env.DEV && import.meta.env.VITE_SKIP_AUTH === 'true'

export function AdminGuard({ children }: AdminGuardProps) {
  const { isAdmin, isAuthenticated, loading } = useAuth()

  if (DEV_SKIP_AUTH) {
    return isAdmin ? <>{children}</> : <Navigate to="/dashboard" replace />
  }

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-indigo-600 border-t-transparent" />
      </div>
    )
  }

  if (!isAuthenticated || !isAdmin) {
    return <Navigate to="/dashboard" replace />
  }

  return <>{children}</>
}
